(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import moment from 'moment';
import { GlucoseSystemCodes, getGlucoseMeasurer } from '../lib/GlucoseSystemCodes';

function _getValueQuantity(observation) {
  var valueQuantity = observation.valueQuantity;

  var _ref = valueQuantity || {},
      value = _ref.value,
      unit = _ref.unit;

  if (!value || !unit) {
    return {};
  }

  return "".concat(value, " ").concat(unit);
}

function _mapObservations(observations) {
  var diabetes = {};
  observations.forEach(function (observation) {
    var _ref2 = observation && observation.code || {},
        coding = _ref2.coding;

    var _ref3 = coding && !!coding.length && coding[0] || {},
        code = _ref3.code,
        system = _ref3.system;

    if (!code || !system) {
      return;
    }

    if (!observation.effectiveDateTime) {
      return;
    }

    diabetes.idMap = diabetes.idMap || {};
    diabetes.date = diabetes.date || moment(observation.effectiveDateTime).local().format("ddd, MMM D, YYYY, HH:mm"); // Glucose

    var glucoseSystem = Object.keys(GlucoseSystemCodes).find(function (k) {
      return GlucoseSystemCodes[k] === "".concat(system, "|").concat(code);
    });
    diabetes.idMap.glucose = observation.id;
    diabetes = Object.assign({}, diabetes, {
      glucoseValue: _getValueQuantity(observation),
      glucoseSystem: glucoseSystem,
      glucoseMeasurer: getGlucoseMeasurer(glucoseSystem)
    });
  });

  if (!Object.keys(diabetes).length) {
    return null;
  }

  return diabetes;
}

export default function mapFromFHIR(observationBundleEntry) {
  // Group observations by effectiveDateTime
  var observationsByDateTime = observationBundleEntry.reduce(function (acc, obs) {
    var _ref4 = obs || {},
        resource = _ref4.resource;

    var _ref5 = resource || {},
        effectiveDateTime = _ref5.effectiveDateTime;

    if (!effectiveDateTime) {
      return acc;
    }

    acc[effectiveDateTime] = acc[effectiveDateTime] || [];
    acc[effectiveDateTime].push(resource);
    return acc;
  }, {});
  var glucoseList = []; // Find Diabetes values in Observations

  Object.values(observationsByDateTime).forEach(function (observations) {
    // Glucose
    var glucoseObservations = observations.filter(function (obs) {
      var _ref6 = obs && obs.code || {},
          coding = _ref6.coding;

      var _ref7 = coding && !!coding.length && coding[0] || {},
          code = _ref7.code,
          system = _ref7.system;

      return Object.values(GlucoseSystemCodes).includes("".concat(system, "|").concat(code));
    });

    var glucose = _mapObservations(glucoseObservations);

    if (glucose) {
      glucoseList.push(glucose);
    }
  });
  return glucoseList;
}
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_getValueQuantity, "_getValueQuantity", "/home/runner/html/nextcloud/apps/ehr/js/plugins/diabetes/src/mappers/mapFromFHIR.js");
  reactHotLoader.register(_mapObservations, "_mapObservations", "/home/runner/html/nextcloud/apps/ehr/js/plugins/diabetes/src/mappers/mapFromFHIR.js");
  reactHotLoader.register(mapFromFHIR, "mapFromFHIR", "/home/runner/html/nextcloud/apps/ehr/js/plugins/diabetes/src/mappers/mapFromFHIR.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();